import { Response } from "@/models/shared/Response";
import { PinRecoverRequest } from "@/models/shared/PinRecoverRequest";
import { PinRecoverResponse } from "@/models/shared/PinRecoverResponse";

export interface IPinRecoverService {
  pinRecover(
    pinRecover: PinRecoverRequest,
    pinRecoverUrl: string
  ): Promise<Response<PinRecoverResponse>>;
}

export class PinRecoverService implements IPinRecoverService {
  async pinRecover(
    pinRecover: PinRecoverRequest,
    pinRecoverUrl: string
  ): Promise<Response<PinRecoverResponse>> {
    const resp = await fetch(pinRecoverUrl, {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(pinRecover),
    });
    if (resp.ok) {
      return { kind: "success", value: await resp.json() };
    } else if (resp.status === 400) {
      const error = await resp.json();

      const returnedError = error.find((c: any) => c.Code != null);
      return {
        kind: "error",
        code: returnedError.Code ? returnedError.Code : 0,
        message: returnedError.message ? returnedError.message : "",
      };
    } else {
      return {
        kind: "unexpected_error",
      };
    }
  }
}

export const pinRecoverService = new PinRecoverService();
